function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.4175 13.5063c-.6052-.097-1.0498-.6091-1.0502-1.21v-.8021l2.1332-1.3522V2.7043h-.1693c-.6917 0-1.2522-.5491-1.2522-1.227V1.227C4.079.55 4.6395 0 5.3312 0h8.8704c.691 0 1.2523.55 1.2523 1.227v.2504c0 .6778-.5614 1.227-1.2523 1.227h-.1692v1.3825l-9.6149 9.4194zm3.927.9392l5.6879-5.5727v1.2692h-.0035l2.1358 1.3522v.8013c0 .6777-.5605 1.2269-1.2523 1.2269h-3.724v6.7608l-1.4224 1.353-1.4215-1.3522v-5.8385zM18.5734 2.0248a.8376.8376 0 0 1 .2533.5987c0 .2246-.0912.44-.2533.5987L1.4742 19.9752c-.3374.3303-.8844.3302-1.2216-.0005a.8343.8343 0 0 1 .0004-1.1969l17.0992-16.753c.3372-.3303.884-.3303 1.2212 0z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 19,
    height: 22
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/pin-disable.3a072f27.svg";
export { SvgComponent as ReactComponent };